import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=7c5555b7&scoped=true&"
import script from "./Faqs.vue?vue&type=script&lang=ts&"
export * from "./Faqs.vue?vue&type=script&lang=ts&"
import style0 from "./Faqs.vue?vue&type=style&index=0&id=7c5555b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5555b7",
  null
  
)

export default component.exports